export default {"src":"/_next/static/media/caution.5cd5027a.svg","height":19,"width":22,"blurWidth":0,"blurHeight":0};